import React, { useMemo } from 'react';

export default function StepperHeader({ title, subtitle, steps, activeIndex, onBack }) {
  const progressPercent = useMemo(() => {
    if (!steps || steps.length <= 1) return 0;
    const clamped = Math.max(0, Math.min(activeIndex, steps.length - 1));
    return Math.round((clamped / (steps.length - 1)) * 100);
  }, [activeIndex, steps]);

  return (
    <div className="yk-stepper">
      <div className="yk-stepper__top">
        <div>
          <div className="yk-stepper__title">{title}</div>
          {subtitle ? <div className="yk-stepper__subtitle">{subtitle}</div> : null}
        </div>
        {onBack ? (
          <button type="button" className="yk-btn yk-btn--secondary yk-btn--sm" onClick={onBack}>
            Back
          </button>
        ) : null}
      </div>

      <div className="yk-progress">
        <div className="yk-progress__track">
          <div className="yk-progress__fill" style={{ width: `${progressPercent}%` }} />
        </div>
      </div>

      <div className="yk-steps">
        {steps.map((s, idx) => {
          const status = idx < activeIndex ? 'completed' : idx === activeIndex ? 'active' : 'pending';
          const iconText = status === 'completed' ? '✓' : status === 'active' ? '•' : '';
          return (
            <div key={s.key} className={['yk-step', `yk-step--${status}`].join(' ')}>
              <div className={['yk-step__icon', `yk-step__icon--${status}`].join(' ')}>
                {iconText}
              </div>
              <div className="yk-step__label">{s.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
